import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIRouterModule } from '@uirouter/angular';
import { AccountAllocationsModule } from './account-allocations/account-allocations.module';
import { AccountContainerComponent } from './account-container/account-container.component';
import { AccountRoute } from './account.route';
import { AccountEffects } from './store/account.effects';
import * as fromAccount from './store/account.reducer';

@NgModule({
    declarations: [AccountContainerComponent],
    imports: [
        CommonModule,
        UIRouterModule,
        StoreModule.forFeature(
            fromAccount.accountsFeatureKey,
            fromAccount.reducer
        ),
        EffectsModule.forFeature([AccountEffects]),
        UIRouterModule.forChild({
            states: [AccountRoute]
        }),
        AccountAllocationsModule
    ]
    // schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AccountModule {}
